import { computePosition } from '@floating-ui/dom';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();
let scrollLockingPopupsCount = 0;

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    popupStyles: {
      type: Object,
      default: () => ({}),
    },
    lockScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPopupVisible: false,
    };
  },
  computed: {
    getPopupId() {
      return this.id || this.generateRandomId('popup-');
    },
  },
  methods: {
    generateRandomId,
    openPopup() {
      if (this.disable || this.isPopupVisible) {
        return;
      }

      this.isPopupVisible = true;
      if (this.lockScroll) {
        scrollLockingPopupsCount++;
      }
      this.$emit('visibility-change', { id: this.getPopupId, isVisible: this.isPopupVisible });
      this.updatePopupPosition();
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);

      if (scrollLockingPopupsCount === 1) {
        document.body.style.overflow = 'hidden';
      }
    },
    togglePopup() {
      if (this.disable) {
        return;
      }

      this.isPopupVisible = !this.isPopupVisible;

      if (this.isPopupVisible) {
        if (this.lockScroll) {
          scrollLockingPopupsCount++;
        }
        this.updatePopupPosition();
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('keydown', this.handleKeyDown);

        if (scrollLockingPopupsCount === 1) {
          document.body.style.overflow = 'hidden';
        }
      } else {
        if (this.lockScroll) {
          scrollLockingPopupsCount = Math.max(0, scrollLockingPopupsCount - 1);
        }
        this.cleanupListeners();
      }

      this.$emit('visibility-change', { id: this.getPopupId, isVisible: this.isPopupVisible });
    },
    closePopup(id = null) {
      if (id && id !== this.getPopupId && !this.isPopupVisible) {
        return;
      }

      this.isPopupVisible = false;
      if (this.lockScroll) {
        scrollLockingPopupsCount = Math.max(0, scrollLockingPopupsCount - 1);
      }
      this.$emit('visibility-change', { id: this.getPopupId, isVisible: this.isPopupVisible });
      this.cleanupListeners();
    },
    handleClickOutside(event) {
      if (
        this.$refs.popupContent &&
        !this.$refs.popupContent.contains(event.target) &&
        (!this.$refs.popupBox || !this.$refs.popupBox.contains(event.target))
      ) {
        this.closePopup(this.getPopupId);
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.closePopup(this.getPopupId);
      } else if(event.key === 'Enter' || event.key === 'Space') {
        this.$emit('default-selected', this.getPopupId);
        this.closePopup(this.getPopupId);
      }
    },
    cleanupListeners() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);

      if (scrollLockingPopupsCount === 0) {
        document.body.style.overflow = '';
      }
    },
    updatePopupPosition() {
      if (!this.$refs.popupBox || !this.$refs.popupContent) return;

      computePosition(this.$refs.popupBox, this.$refs.popupContent, {
        placement: this.placement,
      }).then(({ x, y }) => {
        const computedStyles = {
          ...this.popupStyles,
          left: `${x + (Number(this.popupStyles?.left) || 0)}px`,
          top: `${y + (Number(this.popupStyles?.top) || 0)}px`,
          position: this.popupStyles?.position || 'absolute',
        };

        Object.assign(this.$refs.popupContent.style, computedStyles);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updatePopupPosition();
    });
  },
  beforeDestroy() {
    if (this.isPopupVisible && this.lockScroll) {
      scrollLockingPopupsCount = Math.max(0, scrollLockingPopupsCount - 1);
    }
    this.cleanupListeners();
  },
};
